import React from "react"
import { signOut } from "firebase/auth";
import { auth, addHorario, updateHorario, getDiasFestivosPorAñoyMes, getTrabajadores, existeRegistro, getRegistro, getTrabajadoresActivos, getRegistrosPorAñoyMes } from "../../firebase/firebase"
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import settings from "../../img/settings.png"
import logoblanco from "../../img/logo-blanco.svg"
import { ModalAjustes } from "./modalAjustes/ModalAjustes"
import { ModalDiasFestivos } from "./modalDiasFestivos/ModalDiasFestivos"
import { ModalInformes } from "./modalInformes/ModalInformes"
import { useModalAjustes } from "./modalAjustes/UseModalAjustes"
import { useModalDiasFestivos } from "./modalDiasFestivos/UseModalDiasFestivos"
import { useModalInformes } from "./modalInformes/UseModalInformes"
import { RegistroDiasFestivos } from "./RegistroDiasFestivos"
import { PROJECT_APP, ECINNOVA, INSERTATOLEDO, CARITASTOLEDO, colorProject } from "./../../js/project"
import { calcHorasSemanales, formatDate, formatNumber, getFormatActualMonth, getFormatActualYear, getNombreMesByFecha } from "../../js/functions";
import { BLANK, MONTHS, YEARS } from "../../js/consts";
import { JornadaSemanal } from "./JornadaSemanal";
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import { InformeMensualExcel } from "./InformeMensualExcel";

export default function Header({ user, horariosPrestablecidos }) {
  const navigate = useNavigate();
  const [isOpenModal, openModal, closeModal] = useModalAjustes(false)
  const [isOpenModalDiasFestivos, openModalDiasFestivos, closeModalDiasFestivos] = useModalDiasFestivos(false)
  const [isOpenModalInformes, openModalInformes, closeModalInformes] = useModalInformes(false)
  // const [nombre, setNombre] = useState(trabajador.name)
  // const [apellidos, setApellidos] = useState(trabajador.apellidos)
  // const [dni, setDNI] = useState(trabajador.dni)
  // const [mensajeCambioNombreyApellidos, setMensajeCambioNombreyApellidos] = useState("")
  // const [cambioConfirmado, setCambioConfirmado] = useState(false)
  const [nombreHorario, setNombreHorario] = useState("")
  const [mensajeNombreHorario, setMensajeNombreHorario] = useState("Establece nombre para nuevo horario")
  const [horarioPre, setHorarioPre] = useState("")
  const horarioVacio = [
    {inicio:"", fin:"", inicioTarde:"", finTarde:"", dobleDia:false}, //DOMINGO     0
    {inicio:"", fin:"", inicioTarde:"", finTarde:"", dobleDia:false}, //LUNES       1
    {inicio:"", fin:"", inicioTarde:"", finTarde:"", dobleDia:false}, //MARTES      2
    {inicio:"", fin:"", inicioTarde:"", finTarde:"", dobleDia:false}, //MIERCOLES   3
    {inicio:"", fin:"", inicioTarde:"", finTarde:"", dobleDia:false}, //JUEVES      4
    {inicio:"", fin:"", inicioTarde:"", finTarde:"", dobleDia:false}, //VIERNES     5
    {inicio:"", fin:"", inicioTarde:"", finTarde:"", dobleDia:false}, //SABADO      6
  ]
  const [horarioIndividual, setHorarioIndividual] = useState(horarioVacio)

  const stateDiasHorario = [
    {mañana:true, tarde:false, dobleDia:false}, //DOMINGO     0
    {mañana:true, tarde:false, dobleDia:false}, //LUNES       1
    {mañana:true, tarde:false, dobleDia:false}, //MARTES      2
    {mañana:true, tarde:false, dobleDia:false}, //MIERCOLES   3
    {mañana:true, tarde:false, dobleDia:false}, //JUEVES      4
    {mañana:true, tarde:false, dobleDia:false}, //VIERNES     5
    {mañana:true, tarde:false, dobleDia:false}, //SABADO      6
  ]
  const [booleansHorarioIndividual, setBooleansHorarioIndividual] = useState(stateDiasHorario)
  const [tardeLunes, setTardeLunes] = useState(false)
  const [mañanaLunes, setMañanaLunes] = useState(true)
  const [dobleDiaLunes, setDobleDiaLunes] = useState(false)
  const [tardeMartes, setTardeMartes] = useState(false)
  const [mañanaMartes, setMañanaMartes] = useState(true)
  const [dobleDiaMartes, setDobleDiaMartes] = useState(false)
  const [tardeMiercoles, setTardeMiercoles] = useState(false)
  const [mañanaMiercoles, setMañanaMiercoles] = useState(true)
  const [dobleDiaMiercoles, setDobleDiaMiercoles] = useState(false)
  const [tardeJueves, setTardeJueves] = useState(false)
  const [mañanaJueves, setMañanaJueves] = useState(true)
  const [dobleDiaJueves, setDobleDiaJueves] = useState(false)
  const [tardeViernes, setTardeViernes] = useState(false)
  const [mañanaViernes, setMañanaViernes] = useState(true)
  const [dobleDiaViernes, setDobleDiaViernes] = useState(false)
  const [tardeSabado, setTardeSabado] = useState(false)
  const [mañanaSabado, setMañanaSabado] = useState(false)
  const [dobleDiaSabado, setDobleDiaSabado] = useState(false)
  const [tardeDomingo, setTardeDomingo] = useState(false)
  const [mañanaDomingo, setMañanaDomingo] = useState(false)
  const [dobleDiaDomingo, setDobleDiaDomingo] = useState(false)
  const [mensajeErrorHorarioIndividual, setMensajeErrorHorarioIndividual] = useState("")
  const [totalHorasSemanales, setTotalHorasSemanales] = useState("00:00")
  const [stateNuevoHorario, setStateNuevoHorario] = useState(true)
  const [horarioSeleccionado, setHorarioSeleccionado] = useState(false)

  const [bRegistros, setBRegistros] = useState(false);
  const [diasMes, setDiasMes] = useState([]);
  const [añoSelect, setAñoSelect] = useState(getFormatActualYear())
  const [mesSelect, setMesSelect] = useState(getFormatActualMonth())

  const [display, setDisplay] = useState("none")

  const [incluirTrabajadoresInactivos, setIncluirTrabajadoresInactivos] = useState(false)
  const [botonJornadaSemanal, setBotonJornadaSemanal] = useState(false)
  const [botonJornadaSemanalLoading, setBotonJornadaSemanalLoading] = useState(false)
  const [botonJornadaSemanalAnteriorLoading, setBotonJornadaSemanalAnteriorLoading] = useState(false)
  const [botonInformeMensual, setBotonInformeMensual] = useState(false)

  const [registrosSemanales, setRegistrosSemanales] = useState(null)
  const [registrosMensuales, setRegistrosMensuales] = useState(null)

  const [añoSelectInformes, setAñoSelectInformes] = useState(getFormatActualYear())
  const [mesSelectInformes, setMesSelectInformes] = useState(getFormatActualMonth())

  async function onClickAceptar() {
    comprobarCheckboxes()
    for (let i = 0; i < horarioIndividual.length; i++) {
      const arrInicio = horarioIndividual[i].inicio.split(":")
      const arrFin = horarioIndividual[i].fin.split(":")

      // Aquí estoy comprobando que si la hora tiene el formato H:MM transformarlo a formato HH:MM
      if (arrInicio[0].length === 1) horarioIndividual[i].inicio = `0${horarioIndividual[i].inicio}`
      if (arrFin[0].length === 1) horarioIndividual[i].fin = `0${horarioIndividual[i].fin}`

      if (parseInt(arrInicio[0]) < 24 && parseInt(arrInicio[0]) >= 0) {
      } else {
        if (i === 0 && mañanaDomingo === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Domingo (turno mañana)"); return "" }
        if (i === 1 && mañanaLunes === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Lunes (turno mañana)"); return "" }
        if (i === 2 && mañanaMartes === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Martes (turno mañana)"); return "" }
        if (i === 3 && mañanaMiercoles === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Miercoles (turno mañana)"); return "" }
        if (i === 4 && mañanaJueves === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Jueves (turno mañana)"); return "" }
        if (i === 5 && mañanaViernes === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Viernes (turno mañana)"); return "" }
        if (i === 6 && mañanaSabado === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Sabado (turno mañana)"); return "" }
      }

      if (parseInt(arrInicio[1]) < 60 && parseInt(arrInicio[1]) >= 0) {
      } else {
        if (i === 0 && mañanaDomingo === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Domingo (turno mañana)"); return "" }
        if (i === 1 && mañanaLunes === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Lunes (turno mañana)"); return "" }
        if (i === 2 && mañanaMartes === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Martes (turno mañana)"); return "" }
        if (i === 3 && mañanaMiercoles === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Miercoles (turno mañana)"); return "" }
        if (i === 4 && mañanaJueves === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Jueves (turno mañana)"); return "" }
        if (i === 5 && mañanaViernes === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Viernes (turno mañana)"); return "" }
        if (i === 6 && mañanaSabado === true) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Sabado (turno mañana)"); return "" }
      } 

      if (parseInt(arrFin[0]) < 24 && parseInt(arrFin[0]) >= 0) {
      } else {
        if (i === 0 && mañanaDomingo === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Domingo (turno mañana)"); return "" }
        if (i === 1 && mañanaLunes === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Lunes (turno mañana)"); return "" }
        if (i === 2 && mañanaMartes === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Martes (turno mañana)"); return "" }
        if (i === 3 && mañanaMiercoles === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Miercoles (turno mañana)"); return "" }
        if (i === 4 && mañanaJueves === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Jueves (turno mañana)"); return "" }
        if (i === 5 && mañanaViernes === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Viernes (turno mañana)"); return "" }
        if (i === 6 && mañanaSabado === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Sabado (turno mañana)"); return "" }
      } 

      if (parseInt(arrFin[1]) < 60 && parseInt(arrInicio[1]) >= 0) {
      } else {
        if (i === 0 && mañanaDomingo === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Domingo (turno mañana)"); return "" }
        if (i === 1 && mañanaLunes === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Lunes (turno mañana)"); return "" }
        if (i === 2 && mañanaMartes === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Martes (turno mañana)"); return "" }
        if (i === 3 && mañanaMiercoles === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Miercoles (turno mañana)"); return "" }
        if (i === 4 && mañanaJueves === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Jueves (turno mañana)"); return "" }
        if (i === 5 && mañanaViernes === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Viernes (turno mañana)"); return "" }
        if (i === 6 && mañanaSabado === true) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Sabado (turno mañana)"); return "" }
      }
    }
    for (let i = 0; i < horarioIndividual.length; i++) {
      const arrInicio = horarioIndividual[i].inicioTarde.split(":")
      const arrFin = horarioIndividual[i].finTarde.split(":")

      // Aquí estoy comprobando que si la hora tiene el formato H:MM transformarlo a formato HH:MM
      if (arrInicio[0].length === 1) horarioIndividual[i].inicioTarde = `0${horarioIndividual[i].inicioTarde}`
      if (arrFin[0].length === 1) horarioIndividual[i].finTarde = `0${horarioIndividual[i].finTarde}`

      if (parseInt(arrInicio[0]) < 24 && parseInt(arrInicio[0]) >= 0) {
      } else {
        if (i === 0 && tardeDomingo === true && !dobleDiaDomingo) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Domingo (turno tarde)"); return "" }
        if (i === 1 && tardeLunes === true && !dobleDiaLunes) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Lunes (turno tarde)"); return "" }
        if (i === 2 && tardeMartes === true && !dobleDiaMartes) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Martes (turno tarde)"); return "" }
        if (i === 3 && tardeMiercoles === true && !dobleDiaMiercoles) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Miercoles (turno tarde)"); return "" }
        if (i === 4 && tardeJueves === true && !dobleDiaJueves) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Jueves (turno tarde)"); return "" }
        if (i === 5 && tardeViernes === true && !dobleDiaViernes) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Viernes (turno tarde)"); return "" }
        if (i === 6 && tardeSabado === true && !dobleDiaSabado) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Sabado (turno tarde)"); return "" }
      }

      if (parseInt(arrInicio[1]) < 60 && parseInt(arrInicio[1]) >= 0) {
      } else {
        if (i === 0 && tardeDomingo === true && !dobleDiaDomingo) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Domingo (turno tarde)"); return "" }
        if (i === 1 && tardeLunes === true && !dobleDiaLunes) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Lunes (turno tarde)"); return "" }
        if (i === 2 && tardeMartes === true && !dobleDiaMartes) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Martes (turno tarde)"); return "" }
        if (i === 3 && tardeMiercoles === true && !dobleDiaMiercoles) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Miercoles (turno tarde)"); return "" }
        if (i === 4 && tardeJueves === true && !dobleDiaJueves) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Jueves (turno tarde)"); return "" }
        if (i === 5 && tardeViernes === true && !dobleDiaViernes) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Viernes (turno tarde)"); return "" }
        if (i === 6 && tardeSabado === true && !dobleDiaSabado) { setMensajeErrorHorarioIndividual("Error en la hora de inicio del Sabado (turno tarde)"); return "" }
      } 

      if (parseInt(arrFin[0]) < 24 && parseInt(arrFin[0]) >= 0) {
      } else {
        if (i === 0 && tardeDomingo === true && !dobleDiaDomingo) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Domingo (turno tarde)"); return "" }
        if (i === 1 && tardeLunes === true && !dobleDiaLunes) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Lunes (turno tarde)"); return "" }
        if (i === 2 && tardeMartes === true && !dobleDiaMartes) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Martes (turno tarde)"); return "" }
        if (i === 3 && tardeMiercoles === true && !dobleDiaMiercoles) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Miercoles (turno tarde)"); return "" }
        if (i === 4 && tardeJueves === true && !dobleDiaJueves) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Jueves (turno tarde)"); return "" }
        if (i === 5 && tardeViernes === true && !dobleDiaViernes) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Viernes (turno tarde)"); return "" }
        if (i === 6 && tardeSabado === true && !dobleDiaSabado) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Sabado (turno tarde)"); return "" }
      } 

      if (parseInt(arrFin[1]) < 60 && parseInt(arrInicio[1]) >= 0) {
      } else {
        if (i === 0 && tardeDomingo === true && !dobleDiaDomingo) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Domingo (turno tarde)"); return "" }
        if (i === 1 && tardeLunes === true && !dobleDiaLunes) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Lunes (turno tarde)"); return "" }
        if (i === 2 && tardeMartes === true && !dobleDiaMartes) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Martes (turno tarde)"); return "" }
        if (i === 3 && tardeMiercoles === true && !dobleDiaMiercoles) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Miercoles (turno tarde)"); return "" }
        if (i === 4 && tardeJueves === true && !dobleDiaJueves) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Jueves (turno tarde)"); return "" }
        if (i === 5 && tardeViernes === true && !dobleDiaViernes) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Viernes (turno tarde)"); return "" }
        if (i === 6 && tardeSabado === true && !dobleDiaSabado) { setMensajeErrorHorarioIndividual("Error en la hora de fin del Sabado (turno tarde)"); return "" }
      }
    }
    setMensajeErrorHorarioIndividual("")

    if (stateNuevoHorario === true) {
      const id = `${parseInt(horariosPrestablecidos[horariosPrestablecidos.length-1].id) + 1}`
            
      // if (id >= 1 && id <= 9) id = `00${id}`
      // else if (id >= 10 && id <= 99) id = `0${id}`

      const horario = {
        name: nombreHorario,
        dias: horarioIndividual,
        id: id
      }
      await addHorario(horario)
      window.location.reload()

    }
    else if (stateNuevoHorario === false && horarioSeleccionado === true) {
      const id = `${horariosPrestablecidos[horarioPre].id}`
      const horario = {
        name: nombreHorario,
        dias: horarioIndividual,
        id: id
      }
      await updateHorario(horario)
      window.location.reload()

    } else setMensajeErrorHorarioIndividual("No has seleccionado horario para editar")
  }

  function comprobarCheckboxes() {
    if (mañanaLunes === false) { horarioIndividual[1].inicio = ""; horarioIndividual[1].fin = ""; horarioIndividual[1].inicioTarde = ""; horarioIndividual[1].finTarde = "" }
    if (mañanaMartes === false) { horarioIndividual[2].inicio = ""; horarioIndividual[2].fin = ""; horarioIndividual[2].inicioTarde = ""; horarioIndividual[2].finTarde = "" }
    if (mañanaMiercoles === false) { horarioIndividual[3].inicio = ""; horarioIndividual[3].fin = ""; horarioIndividual[3].inicioTarde = ""; horarioIndividual[3].finTarde = "" }
    if (mañanaJueves === false) { horarioIndividual[4].inicio = ""; horarioIndividual[4].fin = ""; horarioIndividual[4].inicioTarde = ""; horarioIndividual[4].finTarde = "" }
    if (mañanaViernes === false) { horarioIndividual[5].inicio = ""; horarioIndividual[5].fin = ""; horarioIndividual[5].inicioTarde = ""; horarioIndividual[5].finTarde = "" }
    if (mañanaSabado === false) { horarioIndividual[6].inicio = ""; horarioIndividual[6].fin = ""; horarioIndividual[6].inicioTarde = ""; horarioIndividual[6].finTarde = "" }
    if (mañanaDomingo === false) { horarioIndividual[0].inicio = ""; horarioIndividual[0].fin = ""; horarioIndividual[0].inicioTarde = ""; horarioIndividual[0].finTarde = "" }

    if (tardeLunes === false || dobleDiaLunes === true) { horarioIndividual[1].inicioTarde = ""; horarioIndividual[1].finTarde = "" }
    if (tardeMartes === false || dobleDiaMartes === true) { horarioIndividual[2].inicioTarde = ""; horarioIndividual[2].finTarde = "" }
    if (tardeMiercoles === false || dobleDiaMiercoles === true) { horarioIndividual[3].inicioTarde = ""; horarioIndividual[3].finTarde = "" }
    if (tardeJueves === false || dobleDiaJueves === true) { horarioIndividual[4].inicioTarde = ""; horarioIndividual[4].finTarde = "" }
    if (tardeViernes === false || dobleDiaViernes === true) { horarioIndividual[5].inicioTarde = ""; horarioIndividual[5].finTarde = "" }
    if (tardeSabado === false || dobleDiaSabado === true) { horarioIndividual[6].inicioTarde = ""; horarioIndividual[6].finTarde = "" }
    if (tardeDomingo === false || dobleDiaDomingo === true) { horarioIndividual[0].inicioTarde = ""; horarioIndividual[0].finTarde = "" }
  }

  function onChangeMañanaLunes(e) {
    if (e.target.value === "true") { setMañanaLunes(false); setTardeLunes(false); setDobleDiaLunes(false); horarioIndividual[1].dobleDia = false }
    if (e.target.value === "false") { setMañanaLunes(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeMañanaMartes(e) {
    if (e.target.value === "true") { setMañanaMartes(false); setTardeMartes(false); setDobleDiaMartes(false); horarioIndividual[2].dobleDia = false }
    if (e.target.value === "false") { setMañanaMartes(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeMañanaMiercoles(e) {
    if (e.target.value === "true") { setMañanaMiercoles(false); setTardeMiercoles(false); setDobleDiaMiercoles(false); horarioIndividual[3].dobleDia = false }
    if (e.target.value === "false") { setMañanaMiercoles(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeMañanaJueves(e) {
    if (e.target.value === "true") { setMañanaJueves(false); setTardeJueves(false); setDobleDiaJueves(false); horarioIndividual[4].dobleDia = false }
    if (e.target.value === "false") { setMañanaJueves(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeMañanaViernes(e) {
    if (e.target.value === "true") {  setMañanaViernes(false); setTardeViernes(false); setDobleDiaViernes(false); horarioIndividual[5].dobleDia = false }
    if (e.target.value === "false") { setMañanaViernes(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeMañanaSabado(e) {
    if (e.target.value === "true") { setMañanaSabado(false); setTardeSabado(false); setDobleDiaSabado(false); horarioIndividual[6].dobleDia = false }
    if (e.target.value === "false") { setMañanaSabado(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeMañanaDomingo(e) {
    if (e.target.value === "true") { setMañanaDomingo(false); setTardeDomingo(false); setDobleDiaDomingo(false); horarioIndividual[0].dobleDia = false }
    if (e.target.value === "false") { setMañanaDomingo(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeTardeLunes(e) {
    if (e.target.value === "true") { setTardeLunes(false) }
    if (e.target.value === "false") { setTardeLunes(true); setMañanaLunes(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeTardeMartes(e) {
    if (e.target.value === "true") { setTardeMartes(false) }
    if (e.target.value === "false") { setTardeMartes(true); setMañanaMartes(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeTardeMiercoles(e) {
    if (e.target.value === "true") { setTardeMiercoles(false) }
    if (e.target.value === "false") { setTardeMiercoles(true); setMañanaMiercoles(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeTardeJueves(e) {
    if (e.target.value === "true") { setTardeJueves(false) }
    if (e.target.value === "false") { setTardeJueves(true); setMañanaJueves(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeTardeViernes(e) {
    if (e.target.value === "true") { setTardeViernes(false) }
    if (e.target.value === "false") { setTardeViernes(true); setMañanaViernes(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeTardeSabado(e) {
    if (e.target.value === "true") { setTardeSabado(false) }
    if (e.target.value === "false") { setTardeSabado(true); setMañanaSabado(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeTardeDomingo(e) {
    if (e.target.value === "true") { setTardeDomingo(false) }
    if (e.target.value === "false") { setTardeDomingo(true); setMañanaDomingo(true) }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeDobleDiaLunes(e) {
    if (e.target.value === "true") {
      setDobleDiaLunes(false)
      horarioIndividual[1].dobleDia = false
    } 
    else if (e.target.value === "false") {
      setDobleDiaLunes(true); 
      horarioIndividual[1].dobleDia = true
    } 
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeDobleDiaMartes(e) {
    if (e.target.value === "true") {
      setDobleDiaMartes(false); 
      horarioIndividual[2].dobleDia = false
    } 
    else if (e.target.value === "false") {
      setDobleDiaMartes(true); 
      horarioIndividual[2].dobleDia = true
    } 
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeDobleDiaMiercoles(e) {
    if (e.target.value === "true") {
      setDobleDiaMiercoles(false); 
      horarioIndividual[3].dobleDia = false  
    } 
    else if (e.target.value === "false") {
      setDobleDiaMiercoles(true); 
      horarioIndividual[3].dobleDia = true
    } 
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeDobleDiaJueves(e) {
    if (e.target.value === "true") {
      setDobleDiaJueves(false); 
      horarioIndividual[4].dobleDia = false
    } 
    else if (e.target.value === "false") {
      setDobleDiaJueves(true); 
      horarioIndividual[4].dobleDia = true
    } 
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeDobleDiaViernes(e) {
    if (e.target.value === "true") {
      setDobleDiaViernes(false); 
      horarioIndividual[5].dobleDia = false
    } 
    else if (e.target.value === "false") {
      setDobleDiaViernes(true); 
      horarioIndividual[5].dobleDia = true
    } 
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeDobleDiaSabado(e) {
    if (e.target.value === "true") {
      setDobleDiaSabado(false); 
      horarioIndividual[6].dobleDia = false
    } 
    else if (e.target.value === "false") {
      setDobleDiaSabado(true); 
      horarioIndividual[6].dobleDia = true
    } 
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function onChangeDobleDiaDomingo(e) {
    if (e.target.value === "true") {
      setDobleDiaDomingo(false); 
      horarioIndividual[0].dobleDia = false
    } 
    else if (e.target.value === "false") {
      setDobleDiaDomingo(true); 
      horarioIndividual[0].dobleDia = true
    }
    setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))
  }

  function handleStateNuevoHorario(e) {
    if (e.target.value === "false") {
      setStateNuevoHorario(true)
      setMensajeNombreHorario("Establece nombre para nuevo horario")
      calcHorasSemanales("")
      setNombreHorario("")
      setHorarioIndividual(horarioVacio)
      setBooleansDefault()
    }
  }

  function handleStateNuevoHorario2(e) {
    if (e.target.value === "false") {
      setStateNuevoHorario(false)
      setMensajeNombreHorario("Edita el nombre de este horario")
      if(horarioPre !== "") {
          setNombreHorario(horariosPrestablecidos[horarioPre].name)
          setHorarioIndividual(horarioVacio)
          setHorarioIndividual(horariosPrestablecidos[horarioPre].dias)
          setBooleans(horariosPrestablecidos[horarioPre].dias)
          setTotalHorasSemanales(calcHorasSemanales(horariosPrestablecidos[horarioPre].dias))
          //colocarHorarios(horariosPrestablecidos[horarioPre])
      }
    }
  }

  function onChangeSelect(e) {
    if (e.target.value !== BLANK) { 
      setHorarioPre(e.target.value); 
      setNombreHorario(horariosPrestablecidos[e.target.value].name);
      setMensajeNombreHorario("Edita el nombre de este horario")
      setHorarioIndividual(horariosPrestablecidos[e.target.value].dias) 
      setBooleans(horariosPrestablecidos[e.target.value].dias)
      setTotalHorasSemanales(calcHorasSemanales(horariosPrestablecidos[e.target.value].dias))
      setHorarioSeleccionado(true) 
    }
    else {
      setHorarioPre("")
      setNombreHorario("")
      setMensajeNombreHorario("Selecciona horario para editar")
      setBooleansDefault()
      setHorarioIndividual(horarioVacio) 
      calcHorasSemanales("")
      setHorarioSeleccionado(false)
    }
  }

  function setBooleans(horarioTrabajador) {
    for (let i = 0; i < horarioTrabajador.length; i++) {
      if(horarioTrabajador[i].inicio !== "") {
        booleansHorarioIndividual[i].mañana = true
      } 
      else {
        booleansHorarioIndividual[i].mañana = false
      } 

      if(horarioTrabajador[i].inicioTarde !== "") {
        booleansHorarioIndividual[i].tarde = true
      } 
      else {
        booleansHorarioIndividual[i].tarde = false
      } 

      if(horarioTrabajador[i].dobleDia === true) {
        booleansHorarioIndividual[i].dobleDia = true
      } 
      else {
        booleansHorarioIndividual[i].dobleDia = false
      } 
    }
    setBooleansCheckboxes()
  }

  function setBooleansCheckboxes() {
    if (booleansHorarioIndividual[0].mañana === true) setMañanaDomingo(true); else setMañanaDomingo(false)
    if (booleansHorarioIndividual[0].tarde === true) setTardeDomingo(true); else setTardeDomingo(false)
    if (booleansHorarioIndividual[0].dobleDia === true) setDobleDiaDomingo(true); else setDobleDiaDomingo(false)

    if (booleansHorarioIndividual[1].mañana === true) setMañanaLunes(true); else setMañanaLunes(false)
    if (booleansHorarioIndividual[1].tarde === true) setTardeLunes(true); else setTardeLunes(false)
    if (booleansHorarioIndividual[1].dobleDia === true) setDobleDiaLunes(true); else setDobleDiaLunes(false)

    if (booleansHorarioIndividual[2].mañana === true) setMañanaMartes(true); else setMañanaMartes(false)
    if (booleansHorarioIndividual[2].tarde === true) setTardeMartes(true); else setTardeMartes(false)
    if (booleansHorarioIndividual[2].dobleDia === true) setDobleDiaMartes(true); else setDobleDiaMartes(false)

    if (booleansHorarioIndividual[3].mañana === true) setMañanaMiercoles(true); else setMañanaMiercoles(false)
    if (booleansHorarioIndividual[3].tarde === true) setTardeMiercoles(true); else setTardeMiercoles(false)
    if (booleansHorarioIndividual[3].dobleDia === true) setDobleDiaMiercoles(true); else setDobleDiaMiercoles(false)

    if (booleansHorarioIndividual[4].mañana === true) setMañanaJueves(true); else setMañanaJueves(false)
    if (booleansHorarioIndividual[4].tarde === true) setTardeJueves(true); else setTardeJueves(false)
    if (booleansHorarioIndividual[4].dobleDia === true) setDobleDiaJueves(true); else setDobleDiaJueves(false)

    if (booleansHorarioIndividual[5].mañana === true) setMañanaViernes(true); else setMañanaViernes(false)
    if (booleansHorarioIndividual[5].tarde === true) setTardeViernes(true); else setTardeViernes(false)
    if (booleansHorarioIndividual[5].dobleDia === true) setDobleDiaViernes(true); else setDobleDiaViernes(false)

    if (booleansHorarioIndividual[6].mañana === true) setMañanaSabado(true); else setMañanaSabado(false)
    if (booleansHorarioIndividual[6].tarde === true) setTardeSabado(true); else setTardeSabado(false)
    if (booleansHorarioIndividual[6].dobleDia === true) setDobleDiaSabado(true); else setDobleDiaSabado(false)
  }

  function setBooleansDefault() {
    setMañanaLunes(true)
    setTardeLunes(false)
    setDobleDiaLunes(false)

    setMañanaMartes(true)
    setTardeMartes(false)
    setDobleDiaMartes(false)

    setMañanaMiercoles(true)
    setTardeMiercoles(false)
    setDobleDiaMiercoles(false)

    setMañanaJueves(true)
    setTardeJueves(false)
    setDobleDiaJueves(false)

    setMañanaViernes(true)
    setTardeViernes(false)
    setDobleDiaViernes(false)

    setMañanaSabado(false)
    setTardeSabado(false)
    setDobleDiaSabado(false)

    setMañanaDomingo(false)
    setTardeDomingo(false)
    setDobleDiaDomingo(false)
  }

  function inputDisabled() {
    if (horarioSeleccionado === false && stateNuevoHorario === false) {
        return true
    } else return false
  }

//   async function onClickNombreApellidos() {
//       trabajador.nombre = nombre
//       trabajador.apellidos = apellidos
//       trabajador.dni = dni
//       setCambioConfirmado(true)
//       await updateTrabajador(trabajador)
//       setMensajeCambioNombreyApellidos("Cambio confirmado")
//   }

  function logout() {
    signOut(auth)
      .then(() => {
        // console.log("OUT");
        navigate("/login");
      })
      .catch((error) => {
        // console.error(error);
        // console.log("error logout");
      });
  }

  async function establecerDiasMes(año, mes) {
    const diasMesAux = new Date(año, mes, 0).getDate();
    const diasMesFestivos = await getDiasFestivosPorAñoyMes(`${año}-${mes}`)

    for (let dia = 1; dia <= diasMesAux; dia++) {
      const fechaDia = `${año}-${mes}-${formatNumber(dia)}`
      diasMes.push({fechaDia: fechaDia, estado: "LABORAL"})

      for (let i = 0; i < diasMesFestivos.length; i++) {
        if (fechaDia === diasMesFestivos[i].dia) {
          diasMes[dia-1] = {fechaDia: fechaDia, estado: "FESTIVO"}
        }
      }
      if (new Date(fechaDia).getDay() === 0) {
        diasMes[dia-1] = {fechaDia: fechaDia, estado: "DOMINGO"}
      }
    }
    setBRegistros(true)
  }

  function onClickDiasFestivos () {
    establecerDiasMes(añoSelect, mesSelect)
  }

  function onChangeAño (e) {
    setAñoSelect(e.target.value)
    setRegistrosNull()
  }

  function onChangeMes (e) {
    setMesSelect(e.target.value)
    setRegistrosNull()
  }

  function onChangeAñoInformes (e) {
    setAñoSelectInformes(e.target.value)
    setRegistrosMensuales(null)
  }

  function onChangeMesInformes (e) {
    setMesSelectInformes(e.target.value)
    setRegistrosMensuales(null)
  }

  function setRegistrosNull() {
    setBRegistros(false)
    setDiasMes([])
  }

  function controlHorario() {
    navigate("/controlHorario")
  }

  window.document.body.addEventListener("click", () => {
    if (display === "block") setDisplay("none")
  }) 

  function onChangeDisplay() {
    // Aplico un timeout para que se ejecute antes el window.document.body.addEventListener y luego este if
    setTimeout(() => {
      if (display === "none") setDisplay("block")
      else setDisplay("none")
    }, 10)
  }

  function handleIncluirTrabajadoresInactivos() {
    setIncluirTrabajadoresInactivos(!incluirTrabajadoresInactivos)
    setRegistrosMensuales(null)
    setRegistrosSemanales(null)
  }

  async function onClickJornadaSemanal(semanaActualOAnterior) {

    let semanaAnterior = false

    if (semanaActualOAnterior === "semanaanterior") {
      setBotonJornadaSemanalAnteriorLoading(true)
      semanaAnterior = true
    }
    else if (semanaActualOAnterior === "semanaactual") {
      setBotonJornadaSemanalLoading(true)
      semanaAnterior = false
    }

    setBotonJornadaSemanal(true)
    setRegistrosSemanales(null)

    try {
      const trabajadores = incluirTrabajadoresInactivos
        ? await getTrabajadores()
        : await getTrabajadoresActivos();
      const registrosSemanalesAux = trabajadores.map(user => ({
        id: user.uid,
        name: user.name,
        apellidos: user.apellidos,
        horarioPre: user.horarioPre,
        horario: user.horario,
        dias: user.dias,
        horarioSemanal: null,
        registroSemanal: {},
      }));

      registrosSemanalesAux.map(trabajador => {
        if (trabajador.horarioPre === false) {
          trabajador.horarioSemanal = trabajador.dias
        } 
        else {
          // Buscar el horario prestablecido correspondiente al id del trabajador
          const horarioPrestablecido = horariosPrestablecidos.find(horario => horario.id === trabajador.horario);

          if (horarioPrestablecido) {
              // Asignar los días del horario prestablecido al horarioSemanal del trabajador
              trabajador.horarioSemanal = horarioPrestablecido.dias;
          } 
        }
      })
    
      // Ejecuta definirSemana en paralelo para todos los trabajadores
      await Promise.all(trabajadores.map(user => definirSemana(user, registrosSemanalesAux, semanaAnterior)));
    
      // Actualiza el estado después de que todas las promesas se resuelvan
      setRegistrosSemanales(registrosSemanalesAux);

    } catch (error) {
      // console.error("Error al cargar los datos:", error);
    } finally {
      setBotonJornadaSemanal(false); // Reactiva el botón al terminar la consulta
      setBotonJornadaSemanalLoading(false)
      setBotonJornadaSemanalAnteriorLoading(false)
    }
  }

  async function definirSemana(user, registrosSemanalesAux, semanaAnterior) {
    let fechaBase = new Date();
    
    if (semanaAnterior) {
      fechaBase.setDate(fechaBase.getDate() - 7);
    }
  
    let diaSemana = fechaBase.getDay(); // 0=domingo, 1=lunes, ..., 6=sábado
    if (diaSemana === 0) {
      fechaBase.setDate(fechaBase.getDate() - 6); // Si es domingo, retroceder a lunes
    } 
    else {
      fechaBase.setDate(fechaBase.getDate() - diaSemana + 1); // Ir al lunes de la semana
    }
  
    // Recorre los 7 días de la semana
    for (let i = 0; i < 7; i++) {
      let fechaDia = new Date(fechaBase);
      fechaDia.setDate(fechaBase.getDate() + i); // Sumar los días desde el lunes
  
      const fechaFormateada = formatDate(fechaDia);
  
      await setDiasSemana(i, fechaFormateada, user, registrosSemanalesAux);
    }
  }
  
  async function setDiasSemana(i, fechaDia, user, registrosSemanalesAux) {
    const diasSemana = [
      "lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"
    ];
  
    const diaSemana = diasSemana[i];
    const userInRegistrosSemanales = registrosSemanalesAux.find(userArr => userArr.id === user.uid);

    if (await existeRegistro(user, fechaDia)) {
      userInRegistrosSemanales.registroSemanal[diaSemana] = await getRegistro(user, fechaDia);
    } else {
      userInRegistrosSemanales.registroSemanal[diaSemana] = "";
    }
  }

  async function onClickInformeMensual() {
    setBotonInformeMensual(true)
    setRegistrosMensuales(null)

    try {
      const trabajadores = incluirTrabajadoresInactivos
        ? await getTrabajadores()
        : await getTrabajadoresActivos();
      const registrosMensualesAux = trabajadores.map(user => ({
        uid: user.uid,
        name: user.name,
        apellidos: user.apellidos,
        horarioPre: user.horarioPre,
        horario: user.horario,
        dias: user.dias,
        horarioSemanal: null,
        registroMensual: [],
      }));

      registrosMensualesAux.map(trabajador => {
        if (trabajador.horarioPre === false) {
          trabajador.horarioSemanal = trabajador.dias
        } 
        else {
          // Buscar el horario prestablecido correspondiente al id del trabajador
          const horarioPrestablecido = horariosPrestablecidos.find(horario => horario.id === trabajador.horario);

          if (horarioPrestablecido) {
              // Asignar los días del horario prestablecido al horarioSemanal del trabajador
              trabajador.horarioSemanal = horarioPrestablecido.dias;
          } 
        }
      })
    
      await Promise.all(trabajadores.map((user, index) => verRegistros(registrosMensualesAux[index], añoSelectInformes, mesSelectInformes)));
    
      setRegistrosMensuales(registrosMensualesAux);

    } catch (error) {
      // console.error("Error al cargar los datos:", error);
    } finally {
      setBotonInformeMensual(false); // Reactiva el botón al terminar la consulta
    }
  }

  async function verRegistros(user, año, mes) {
    
    // Creo los dias del mes actual pasandole el parametro año y mes
    const diasMes = new Date(año, mes, 0).getDate();

    // Traigo todos los dias festivos por mes y año de la base de datos
    const diasMesFestivos = await getDiasFestivosPorAñoyMes(`${año}-${mes}`)

    // Traigo todos los registros por mes y año de la base de datos
    const registrosDB = await getRegistrosPorAñoyMes(user,`${año}-${mes}`)

    // Hago un for para que recorra cada dia del mes seleccionado
    for (let dia = 1; dia <= diasMes; dia++) {

      // Creo la fecha del dia actual con el formato YYYY-MM-DD
      const fechaDia = `${año}-${mes}-${formatNumber(dia)}`

      // Creo todos los registros en el array de registros con fechaDia, registro "", y el estado en laboral
      user.registroMensual.push({fechaDia: fechaDia, registro: "", estado: "LABORAL"})

      // Si los registros obtenidos de la base de datos de este mes no es un array vacio se ejecuta el if
      if (registrosDB.length !== 0) {

        // Creo un for que recorre todos los registros de la base de datos que con el if de antes ya se que no es 0
        for (let i = 0; i<registrosDB.length; i++) {

          // Si la fechaDia (primer for) es igual a la fecha de cada registro (anterior for) entonces se ejecuta
          if (fechaDia === registrosDB[i].fecha) {

            // Se asigna en el registro[dia-1] (dia-1 porque el dia del mes empieza en 1 pero los arrays empiezan
            // en 0) la fecha (que es la misma que ya estaba asignada), el registro, y el estado laboral ya que
            // estoy dentro del for de los registros => luego le asigno festivo si así toca
            user.registroMensual[dia-1] = {fechaDia: fechaDia, registro: registrosDB[i], estado: "LABORAL"}
          }
        }
      }

      // Si los registros obtenidos de la base de datos de este mes no es un array vacio y los dias
      // festivos obtenidos de la base de datos tampoco es un string vacio entonces se ejecuta el if
      if (registrosDB.length !== 0 && diasMesFestivos.length !== 0) {

        // Creo un for que recorre todos los registros de la base de datos que con el if de antes ya se que no es 0
        for (let i = 0; i<registrosDB.length; i++) {

          // Creo otro for anidado al anterior que recorre todos los dias festivos de la base de datos
          // que como antes he dicho no es 0 por el if
          for (let d = 0; d < diasMesFestivos.length; d++) {

            // Si la fechaDia (primer for) = a la fecha de los registros (segundo for) entonces se ejecuta el if
            if (fechaDia === diasMesFestivos[d].dia) {

              // Se asigna en el estado del registros[dia-1] (dia-1 porque el dia del mes empieza en 1 pero los arrays empiezan
              // en 0) el string "FESTIVO" ya que todos los dias que entren en este if son festivos
              user.registroMensual[dia-1].estado = "FESTIVO"
            }

            // Si la fechaDia (primer for) = a la fecha de los registros (segundo for) && la fecha dia (primer for)
            // es igual a la fecha de los dias festivos (tercer for) entonces se ejecuta el if
            if (fechaDia === registrosDB[i].fecha && fechaDia === diasMesFestivos[d].dia) {

              // Se asigna en el registro[dia-1] (dia-1 porque el dia del mes empieza en 1 pero los arrays empiezan
              // en 0) la fecha (que es la misma que ya estaba asignada), el registro, y el estado festivo ya que
              // estoy dentro del for de los dias festivos (tercer for)
              user.registroMensual[dia-1] = {fechaDia: fechaDia, registro: registrosDB[i], estado: "FESTIVO"}
            }
          }
        } 
      } 

      // Else => Si los registros obtenidos de la base de datos es un array vacio entonces se ejecuta este if
      else if (registrosDB.length === 0) {

        // Creo un for que recorre todos los dias festivos ya que hemos visto que 
        // no hay registros este mes y minimo hay un dia festivo
        for (let d = 0; d < diasMesFestivos.length; d++) {

          // Si la fechaDia (primer for) es igual a la fecha de cada dia festivo (anterior for) entonces se ejecuta
          if (fechaDia === diasMesFestivos[d].dia) {

            // Se asigna en el registro[dia-1] (dia-1 porque el dia del mes empieza en 1 pero los arrays empiezan
            // en 0) la fecha (que es la misma que ya estaba asignada), el registro se deja en blanco ya que el array
            // de registros es 0 y el estado en festivo ya que en este for estamos recorriendo los dias festivos sin registros
            user.registroMensual[dia-1] = {fechaDia: fechaDia, registro: "", estado: "FESTIVO"}
          } 
        } 
      } 

      // Else => Si los dias festivos obtenidos de la base de datos es un array vacio entonces se ejecuta este if
      else if (diasMesFestivos.length === 0) {

        // Creo un for que recorre todos los registros ya que hemos visto que 
        // no hay dias festivos este mes y minimo hay un registro
        for (let i = 0; i < registrosDB.length; i++) {

          // Si la fechaDia (primer for) es igual a la fecha de cada registro (anterior for) entonces se ejecuta
          if (fechaDia === registrosDB[i].fecha) {

            // Se asigna en el registro[dia-1] (dia-1 porque el dia del mes empieza en 1 pero los arrays empiezan
            // en 0) la fecha (que es la misma que ya estaba asignada), en el registro se asigna el registro de este for
            // y el estado en laboral ya que en el if de antes estamos comprobando que no hay ningun dia festivo
            user.registroMensual[dia-1] = {fechaDia: fechaDia, registro: registrosDB[i], estado: "LABORAL"}
          } 
        }
      }
    }
    // setBRegistros(true)
  }

  return (
    <>
      <nav style={{backgroundColor: colorProject}} className="navheader">
      { PROJECT_APP === ECINNOVA && 
          <>
            <a href="/#/update">
              <img src={logoblanco}
                width="50"
                height="50"
                alt="logo_empresa"
              />
            </a>
            <a href="/#/update">
              <h1 className="colorwhite title-page">EC-INNOVA</h1>
            </a>
          </>
        }
        { PROJECT_APP === INSERTATOLEDO && 
          <a href="/#/update">
            <h1 className="colorwhite pm-0">INSERTA TOLEDO</h1>
          </a>
        }
        { PROJECT_APP === CARITASTOLEDO && 
          <a href="/#/update">
            <h1 className="colorwhite pm-0">CARITAS TOLEDO</h1>
          </a>
        }

        <div className="dropdowncss mleft-auto" onClick={onChangeDisplay}>
          { PROJECT_APP === ECINNOVA && 
            <>
              <img src={settings}
                width="20"
                height="20"
                className="margintop-2"
                alt="logo_empresa"
              />
              <span className="vdropdown">v</span>
            </>
          }
          { PROJECT_APP === INSERTATOLEDO && 
            <span className="marginleft-8">v</span>
          }
          { PROJECT_APP === CARITASTOLEDO && 
            <span className="marginleft-8">v</span>
          }
          <div style={{display: display}} className="dropdownmenucss">
            <button onClick={openModal}>Ajustes</button>
            <button onClick={controlHorario}>Control horario</button>
            <button onClick={openModalDiasFestivos}>Dias festivos</button>
            <button onClick={openModalInformes}>Informes</button>
            <button onClick={logout}>Cerrar sesión</button>
          </div>
        </div>

        <ModalInformes isOpen={isOpenModalInformes} closeModal={closeModalInformes}>
          <div className="titulo2">Informes</div>
          <hr /> 
          <label className="text-bold dblock margintop-8">¿Incluir trabajadores inactivos?&nbsp;
            <input type="checkbox" checked={incluirTrabajadoresInactivos} value={incluirTrabajadoresInactivos} onChange={handleIncluirTrabajadoresInactivos}/>
          </label>
          <hr /> 
          <div className="titulo3">Registros mensuales</div>
          <div>
              Año:&nbsp;
              <select onChange={onChangeAñoInformes} defaultValue={añoSelectInformes}>
                {YEARS.map((year) => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
              &nbsp;

              Mes:&nbsp;
              <select onChange={onChangeMesInformes} defaultValue={mesSelectInformes}>
                {MONTHS.map((month) => (
                  <option key={month.number} value={month.number}>{month.name}</option>
                ))}
              </select>
              &nbsp;&nbsp;
              
              {registrosMensuales ? 
                <ReactHTMLTableToExcel table="informeMensualTable" filename={`Informe_Mensual_${getNombreMesByFecha(registrosMensuales[0].registroMensual[0].fechaDia)}_${new Date(registrosMensuales[0].registroMensual[0].fechaDia).getFullYear()}`} className="successButton" sheet="Hoja 1" buttonText="Descargar" />
                : <button disabled={botonInformeMensual} className="acceptButton" onClick={onClickInformeMensual}> {botonInformeMensual ? "Cargando..." : "Obtener registros mensuales"}</button>
              }
              <InformeMensualExcel registrosMensuales={registrosMensuales} />
              {/* <RegistroDiasExcel registros={registros} trabajador={trabajador} bRegistros={bRegistros}></RegistroDiasExcel> */}
            </div>
          <hr />
          <div className="titulo3">Registros semanales</div>
          <div className="marginbottom-8 button-container">
            <div>
              <button disabled={botonJornadaSemanal} className="acceptButton" onClick={() => onClickJornadaSemanal("semanaanterior")}> {botonJornadaSemanalAnteriorLoading ? "Cargando..." : "Semana anterior"}</button>
              <button disabled={botonJornadaSemanal} className="acceptButton" onClick={() => onClickJornadaSemanal("semanaactual")}> {botonJornadaSemanalLoading ? "Cargando..." : "Semana actual"}</button>
            </div>
            {registrosSemanales ? 
              <ReactHTMLTableToExcel table="jornadaSemanalTable" filename={`Jornada_Semanal_${formatDate(new Date())}`} className="successButton" sheet="Hoja 1" buttonText="Descargar" />
              : null
            }
          </div>
          <JornadaSemanal registrosSemanales={registrosSemanales} />
        </ModalInformes>

        <ModalDiasFestivos isOpen={isOpenModalDiasFestivos} closeModal={closeModalDiasFestivos}>
          <div className="titulo2">Establecer dias festivos</div>
          <hr /> 
          <div className="marginbottom-8">
            Año:&nbsp;
            <select onChange={onChangeAño} defaultValue={añoSelect}>
              {YEARS.map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
            &nbsp;

            Mes:&nbsp;
            <select onChange={onChangeMes} defaultValue={mesSelect}>
              {MONTHS.map((month) => (
                <option key={month.number} value={month.number}>{month.name}</option>
              ))}
            </select>
            &nbsp;&nbsp;
            <button className="acceptButton" onClick={onClickDiasFestivos}>Ver Dias</button>
          </div>
          <RegistroDiasFestivos user={user} diasMes={diasMes} bRegistros={bRegistros}/>
        </ModalDiasFestivos>
        <ModalAjustes isOpen={isOpenModal} closeModal={closeModal}>
          <article id="settings">
            <div className="titulo2">Ajustes</div>
            <hr />
            {/* <h3>Mis datos</h3>
            <table>
              <tbody>
                <tr>
                  <td><label>Correo electronico</label></td>
                  <td><input type="text" disabled={true} value={trabajador.email} /></td>
                </tr>
                <tr>
                  <td><label>Nombre</label></td>
                  <td><input type="text" value={nombre} onChange={(e) => {setNombre(e.target.value)}} /></td>
                </tr>
                <tr>
                  <td><label>Apellidos</label></td>
                  <td><input type="text" value={apellidos} onChange={(e) => {setApellidos(e.target.value)}} /></td>
                </tr>
                <tr>
                  <td><label>DNI</label></td>
                  <td><input type="text" value={dni} onChange={(e) => {setDNI(e.target.value)}} /></td>
                </tr>
              </tbody>
            </table>
            <div>
              <Button disabled={cambioConfirmado} onClick={onClickNombreApellidos}>Confirmar cambio de nombre y/o apellidos</Button>
              <span>&nbsp;{mensajeCambioNombreyApellidos}</span>
            </div>
            <hr /> */}
            <div className="titulo3">Horarios Prestablecidos</div>
            <div>
              <label>
                <input type="checkbox" checked={stateNuevoHorario} value={stateNuevoHorario} onChange={handleStateNuevoHorario}/>
                <span className="text-bold">&nbsp;Añadir nuevo horario</span>
              </label>
            </div>
            <br />
            <div>
              <label>
                <input type="checkbox" checked={!stateNuevoHorario} value={!stateNuevoHorario} onChange={handleStateNuevoHorario2}/>
                <span className="text-bold">&nbsp;Editar horario &nbsp;</span>
              </label>
              <select onChange={onChangeSelect} disabled={stateNuevoHorario}>
                <option key={BLANK} value={BLANK} title={BLANK}></option>
              {horariosPrestablecidos.map((horario, index) => (
                <option key={index} value={index} title={horario.name}>{horario.name}</option>
              ))}
              </select>
            </div>
            <div>
              <span>{mensajeNombreHorario}</span>
              <span>&nbsp;&nbsp;<input type="text" disabled={inputDisabled()} value={nombreHorario} onChange={(e) => {setNombreHorario(e.target.value)}} /></span>
            </div>
            <br />
            <div>Turno mañana/jornada continua</div>
            <table className="scheduleTable">
              <tbody>
                <tr>
                  <td><input type="checkbox" checked={mañanaLunes} value={mañanaLunes} onChange={onChangeMañanaLunes}/></td>
                  <td>Lunes</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaLunes} defaultValue={horarioIndividual[1].inicio} onChange={(e) => {horarioIndividual[1].inicio = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaLunes} defaultValue={horarioIndividual[1].fin} onChange={(e) => {horarioIndividual[1].fin = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td><span>&nbsp;&nbsp;&nbsp;&nbsp;Doble_día:</span></td>
                  <td><input type="checkbox" disabled={!mañanaLunes} checked={dobleDiaLunes} value={dobleDiaLunes} onChange={onChangeDobleDiaLunes}/></td>
                </tr>
                <tr>
                  <td><input type="checkbox" checked={mañanaMartes} value={mañanaMartes} onChange={onChangeMañanaMartes}/></td>
                  <td>Martes</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaMartes} defaultValue={horarioIndividual[2].inicio} onChange={(e) => {horarioIndividual[2].inicio = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaMartes} defaultValue={horarioIndividual[2].fin} onChange={(e) => {horarioIndividual[2].fin = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td><span>&nbsp;&nbsp;&nbsp;&nbsp;Doble_día:</span></td>
                  <td><input type="checkbox" disabled={!mañanaMartes} checked={dobleDiaMartes} value={dobleDiaMartes} onChange={onChangeDobleDiaMartes}/></td>
                </tr>
                <tr>
                  <td><input type="checkbox" checked={mañanaMiercoles} value={mañanaMiercoles} onChange={onChangeMañanaMiercoles}/></td>
                  <td>Miercoles</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaMiercoles} defaultValue={horarioIndividual[3].inicio} onChange={(e) => {horarioIndividual[3].inicio = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaMiercoles} defaultValue={horarioIndividual[3].fin} onChange={(e) => {horarioIndividual[3].fin = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td><span>&nbsp;&nbsp;&nbsp;&nbsp;Doble_día:</span></td>
                  <td><input type="checkbox" disabled={!mañanaMiercoles} checked={dobleDiaMiercoles} value={dobleDiaMiercoles} onChange={onChangeDobleDiaMiercoles}/></td>
                </tr>
                <tr>
                  <td><input type="checkbox" checked={mañanaJueves} value={mañanaJueves} onChange={onChangeMañanaJueves}/></td>
                  <td>Jueves</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaJueves} defaultValue={horarioIndividual[4].inicio} onChange={(e) => {horarioIndividual[4].inicio = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaJueves} defaultValue={horarioIndividual[4].fin} onChange={(e) => {horarioIndividual[4].fin = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td><span>&nbsp;&nbsp;&nbsp;&nbsp;Doble_día:</span></td>
                  <td><input type="checkbox" disabled={!mañanaJueves} checked={dobleDiaJueves} value={dobleDiaJueves} onChange={onChangeDobleDiaJueves}/></td>
                </tr>
                <tr>
                  <td><input type="checkbox" checked={mañanaViernes} value={mañanaViernes} onChange={onChangeMañanaViernes}/></td>
                  <td>Viernes</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaViernes} defaultValue={horarioIndividual[5].inicio} onChange={(e) => {horarioIndividual[5].inicio = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaViernes} defaultValue={horarioIndividual[5].fin} onChange={(e) => {horarioIndividual[5].fin = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td><span>&nbsp;&nbsp;&nbsp;&nbsp;Doble_día:</span></td>
                  <td><input type="checkbox" disabled={!mañanaViernes} checked={dobleDiaViernes} value={dobleDiaViernes} onChange={onChangeDobleDiaViernes}/></td>
                </tr>
                <tr>
                  <td><input type="checkbox" checked={mañanaSabado} value={mañanaSabado} onChange={onChangeMañanaSabado}/></td>
                  <td>Sabado</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaSabado} defaultValue={horarioIndividual[6].inicio} onChange={(e) => {horarioIndividual[6].inicio = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaSabado} defaultValue={horarioIndividual[6].fin} onChange={(e) => {horarioIndividual[6].fin = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td><span>&nbsp;&nbsp;&nbsp;&nbsp;Doble_día:</span></td>
                  <td><input type="checkbox" disabled={!mañanaSabado} checked={dobleDiaSabado} value={dobleDiaSabado} onChange={onChangeDobleDiaSabado}/></td>
                </tr>
                <tr>
                  <td><input type="checkbox" checked={mañanaDomingo} value={mañanaDomingo} onChange={onChangeMañanaDomingo}/></td>
                  <td>Domingo</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaDomingo} defaultValue={horarioIndividual[0].inicio} onChange={(e) => {horarioIndividual[0].inicio = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!mañanaDomingo} defaultValue={horarioIndividual[0].fin} onChange={(e) => {horarioIndividual[0].fin = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td><span>&nbsp;&nbsp;&nbsp;&nbsp;Doble_día:</span></td>
                  <td><input type="checkbox" disabled={!mañanaDomingo} checked={dobleDiaDomingo} value={dobleDiaDomingo} onChange={onChangeDobleDiaDomingo}/></td>
                </tr>
              </tbody>
            </table>

            <div>Turno tarde</div>
            <table className="scheduleTable">
              <tbody>
                <tr>
                  <td><input type="checkbox" disabled={dobleDiaLunes} checked={tardeLunes} value={tardeLunes} onChange={onChangeTardeLunes}/></td>
                  <td>Lunes</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeLunes || dobleDiaLunes} defaultValue={horarioIndividual[1].inicioTarde} onChange={(e) => {horarioIndividual[1].inicioTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeLunes || dobleDiaLunes} defaultValue={horarioIndividual[1].finTarde} onChange={(e) => {horarioIndividual[1].finTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                </tr>
                <tr>
                  <td><input type="checkbox" disabled={dobleDiaMartes} checked={tardeMartes} value={tardeMartes} onChange={onChangeTardeMartes}/></td>
                  <td>Martes</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeMartes || dobleDiaMartes} defaultValue={horarioIndividual[2].inicioTarde} onChange={(e) => {horarioIndividual[2].inicioTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeMartes || dobleDiaMartes} defaultValue={horarioIndividual[2].finTarde} onChange={(e) => {horarioIndividual[2].finTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                </tr>
                <tr>
                  <td><input type="checkbox" disabled={dobleDiaMiercoles} checked={tardeMiercoles} value={tardeMiercoles} onChange={onChangeTardeMiercoles}/></td>
                  <td>Miercoles</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeMiercoles || dobleDiaMiercoles} defaultValue={horarioIndividual[3].inicioTarde} onChange={(e) => {horarioIndividual[3].inicioTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeMiercoles || dobleDiaMiercoles} defaultValue={horarioIndividual[3].finTarde} onChange={(e) => {horarioIndividual[3].finTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                </tr>
                <tr>
                  <td><input type="checkbox" disabled={dobleDiaJueves} checked={tardeJueves} value={tardeJueves} onChange={onChangeTardeJueves}/></td>
                  <td>Jueves</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeJueves || dobleDiaJueves} defaultValue={horarioIndividual[4].inicioTarde} onChange={(e) => {horarioIndividual[4].inicioTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeJueves || dobleDiaJueves} defaultValue={horarioIndividual[4].finTarde} onChange={(e) => {horarioIndividual[4].finTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                </tr>
                <tr>
                  <td><input type="checkbox" disabled={dobleDiaViernes} checked={tardeViernes} value={tardeViernes} onChange={onChangeTardeViernes}/></td>
                  <td>Viernes</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeViernes || dobleDiaViernes} defaultValue={horarioIndividual[5].inicioTarde} onChange={(e) => {horarioIndividual[5].inicioTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeViernes || dobleDiaViernes} defaultValue={horarioIndividual[5].finTarde} onChange={(e) => {horarioIndividual[5].finTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                </tr>
                <tr>
                  <td><input type="checkbox" disabled={dobleDiaSabado} checked={tardeSabado} value={tardeSabado} onChange={onChangeTardeSabado}/></td>
                  <td>Sabado</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeSabado || dobleDiaSabado} defaultValue={horarioIndividual[6].inicioTarde} onChange={(e) => {horarioIndividual[6].inicioTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeSabado || dobleDiaSabado} defaultValue={horarioIndividual[6].finTarde} onChange={(e) => {horarioIndividual[6].finTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                </tr>
                <tr>
                  <td><input type="checkbox" disabled={dobleDiaDomingo} checked={tardeDomingo} value={tardeDomingo} onChange={onChangeTardeDomingo}/></td>
                  <td>Domingo</td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Inicio:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeDomingo || dobleDiaDomingo} defaultValue={horarioIndividual[0].inicioTarde} onChange={(e) => {horarioIndividual[0].inicioTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;Fin:</td>
                  <td><input type="text" maxLength="5" disabled={!tardeDomingo || dobleDiaDomingo} defaultValue={horarioIndividual[0].finTarde} onChange={(e) => {horarioIndividual[0].finTarde = e.target.value; setTotalHorasSemanales(calcHorasSemanales(horarioIndividual))}}/></td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                </tr>
              </tbody>
            </table>
            <div className="text-bold">Total Horas: {totalHorasSemanales}</div>
            <div className="textright">
              <span className="colorred">{mensajeErrorHorarioIndividual}</span>
              <button className="cancelButton" onClick={closeModal}>Cancelar</button>
              <button disabled={user.view_only_admin} className="acceptButton" onClick={onClickAceptar}>Aceptar</button>
            </div>
          </article>
        </ModalAjustes>
      </nav>
    </>
  );
}
